import React, { Suspense, useState } from 'react';
import LazyLoad, { lazyload } from 'react-lazyload';
import { Lottie } from '@crello/react-lottie';

import Head from 'next/head';

import st from './index.module.scss';

import Pricing from '../../../components/video-production/Pricing';
import BradCrumbs from '../../../components/Base/BradCrumbs';
import Engagement from '../../../components/Engagement';
import ViewMore from '../../../components/ViewMore';
import Faq from '../../../components/Faq';
import Why from '../../../components/Why';
import ProcessSliderLiveAction from '../../../components/sliders/ProcessSliderLiveAction';
import BenefitsLiveAction from '../../../components/video-production/explainer-videos/BenefitsLiveAction';

import typesLottie from '../../../public/images/types.json';
import SolveProblemsLiveAction from '../../../components/video-production/explainer-videos/SolveProblemsLiveAction';

lazyload({
  width: '100%',
});

const ExplainerVideosLiveAction = props => {
  const [showPricingModalF, setShowPricingModalF] = useState(false);
  const [videoLength, setVideoLength] = useState([]);
  const [script, setScript] = useState([]);

  const showPricingModal = () => {
    if (props.width < 768) {
      window.location.href = '/video-production/get-pricing';
    } else {
      setShowPricingModalF(true);
      document.body.style.overflow = 'hidden';
      document.documentElement.style.overflow = 'hidden';
      window.location.hash = 'open';
    }
  };
  const hidePricingModal = () => {
    setShowPricingModalF(false);
    document.body.style.overflow = 'auto';
    document.body.style.overflowX = 'hidden';
    history.replaceState(null, null, ' ');
    document.documentElement.style.overflow = 'auto';
  };

  return (
    <>
      <Head>
        <title>Video Production - Live Action Explainer Video | Prodigi</title>
        <link rel="alternate" hrefLang="en" href="https://weprodigi.com/video-production/live-action-explainer-video" />
        <meta
          name="description"
          content="Experience the impact of live action explainer videos. Engage your audience with compelling storytelling and real-life visuals. Enhance your brand now."
        />
        <meta property="og:url" content="https://weprodigi.com/video-production/live-action-explainer-video" />
        <meta property="og:type" content="article" />
        <meta property="og:title" content="Video Production - Live Action Explainer Video | Prodigi" />
        <meta
          property="og:description"
          content="Experience the impact of live action explainer videos. Engage your audience with compelling storytelling and real-life visuals. Enhance your brand now."
        />
        <meta property="og:image" content="https://weprodigi.com/uploads/images/explainer-videos/live-action-explainer/og.jpg" />
        <script
          type="application/ld+json"
          className="organization-schema"
          dangerouslySetInnerHTML={{
            __html: `{
              "@context": "http://schema.org",
              "@type": "WebPage",
              "name": "Video Production - Live Action Explainer Video | Prodigi",
              "description": "Experience the impact of live action explainer videos. Engage your audience with compelling storytelling and real-life visuals. Enhance your brand now.",
              "url": "https://weprodigi.com/video-production/live-action-explainer-video",
              "breadcrumb": {
                "@type": "BreadcrumbList",
                "itemListElement": [
                  {
                    "@type": "ListItem",
                    "position": 1,
                    "name": "Home",
                    "item": "https://weprodigi.com"
                  },
                  {
                    "@type": "ListItem",
                    "position": 2,
                    "name": "Full Service Video Production",
                    "item": "https://weprodigi.com/video-production"
                  },
                  {
                    "@type": "ListItem",
                    "position": 3,
                    "name": "Live Action Explainer Video Production - Prodigi",
                    "item": "https://weprodigi.com/video-production/live-action-explainer-video"
                  }
                ]
              },
              "mainEntity": {
                "@type": "Product",
                "name": "Live Action Explainer Video Production",
                "description": "Experience the impact of live action explainer videos. Engage your audience with compelling storytelling and real-life visuals. Enhance your brand now.",
                "brand": {
                  "@type": "Brand",
                  "name": "Weprodigi"
                },
                "offers": {
                  "@type": "Offer",
                  "price": "3500",
                  "priceCurrency": "USD",
                  "seller": {
                    "@type": "Organization",
                    "name": "Weprodigi"
                  }
                },
                "image": "https://weprodigi.com/images/logovertical.svg",
                "review": [
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Alex Ramirez"
                    },
                    "datePublished": "2023-06-14",
                    "reviewBody": "I recently worked with Live Action Explainer Video Production for a project and I couldn't be happier with the results. Their team's attention to detail and ability to capture our brand's essence in a live-action format was impressive. The video they produced exceeded our expectations and has been a valuable asset in our marketing strategy. Thank you!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "5",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Chris Evans"
                    },
                    "datePublished": "2023-09-28",
                    "reviewBody": "Live Action Explainer Video Production nailed it! Prodigi's creativity and professionalism brought our concept to life seamlessly. Highly recommend!"
                  },
                  {
                    "@type": "Review",
                    "reviewRating": {
                      "@type": "Rating",
                      "ratingValue": "4.9",
                      "bestRating": "5",
                      "worstRating": "1"
                    },
                    "author": {
                      "@type": "Person",
                      "name": "Jessica Lee"
                    },
                    "datePublished": "2024-03-2",
                    "reviewBody": "Live Action Explainer Video Production made our vision a reality! Their attention to detail and expertise resulted in a top-quality video.Thank you Prodigi!"
                  }
                ],
                "aggregateRating": {
                  "@type": "AggregateRating",
                  "ratingValue": "4.9",
                  "reviewCount": "3"
                }
              }
            }              
        `,
          }}
        />
      </Head>

      {/*    Header video */}
      <div className={`relative w-full  h-intro  overflow-hidden  `}>
        <video
          width="100%"
          height="100%"
          autoPlay
          loop
          muted
          playsInline
          preload="none"
          id="header-11"
          className={'absolute h-intro md:h-full ' + st['header-mp4']}
        >
          <source src="https://weprodigi.com/uploads/images/explainer-videos/live-action-explainer/live-action-explainer.mp4" type="video/mp4" />
        </video>
        <div className={st['overlay']}></div>
        <div className="container h-full">
          <div className="relative h-full  flex flex-col flex-wrap justify-center items-start overflow-hidden">
            <h1 className="max-w-300 md:max-w-600 uppercase md:normal-case text-white text-30 md:text-72 font-black md:font-bold leading-tight">
              Live Action Explainer Video Production
            </h1>
            <a
              onClick={showPricingModal}
              className="relative flex items-center justify-center min-w-250 z-10 border-2 rounded-5 border-green-badge hover:border-green-hover text-18 text-white px-23 mt-48 md:mt-23 py-8 bg-green-badge hover:bg-green-hover hover:text-white transition-all   transition-400 cursor-pointer"
            >
              Get Pricing
              <img src="https://weprodigi.com/uploads/images/explainer-videos/buttonIcon.svg" className={'ml-10'} alt="pricing icon" />
            </a>
          </div>
        </div>
      </div>

      <div className="bg-white">
        <div className="container">
          <BradCrumbs
            items={[
              {
                url: '/video-production',
                name: 'Video Production',
              },
              {
                url: '/video-production/explainer-videos',
                name: 'Explainer Video Production',
              },
              {
                url: '/video-production/live-action-explainer-video',
                name: 'Live Action Explainer Video',
              },
            ]}
          />
          <div className="relative pt-20 md:pt-0 pb-48">
            <div className="flex flex-wrap md:flex-nowrap justify-between">
              <LazyLoad className="mr-auto mt-24 md:mt-0 max-w-270 w-full md:w-auto" height={200} once>
                <Lottie
                  config={{
                    animationData: typesLottie,
                    loop: true,
                    autoPlay: true,
                  }}
                  playingState="playing"
                />
              </LazyLoad>
              <div className="flex flex-col ml-12 items-center justify-center max-w-756">
                <Engagement title="Video">
                  A live-action explainer video is popular and will remain so. That proves one simple thing: people like to see other people.
                  Especially, in today's world, where animated videos are everywhere, many people crave for something simple and real. And that's what
                  live-action videos offer.
                </Engagement>
              </div>
            </div>
          </div>
        </div>
      </div>

      <LazyLoad height={200} once>
        <div className={'bg-gray-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-half-auto font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              What Is Live Action Explainer Video?
            </h2>

            <div className={'block md:flex justify-between flex-row md:flex-row-reverse'}>
              <div className=" pl-0 md:pl-20 pb-10 w-full md:w-half-auto block  mt-23 mb-10">
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/otoq2-bJHiU?controls=0"
                    title="YouTube video player"
                    frameBorder="0"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Perfect Skin | Product Live Action Video</p>
              </div>

              <p className={'mt-20 w-half-auto hidden md:block'}>
                An amazing short movie that helps viewers understand ideas in an easy way. Here is a live action explainer video! It smoothly mixes
                real-world elements, interesting narration, and voiceovers to describe a product, service, or idea. What are the benefits of these
                videos over animations? They add a human touch to the message speaking directly to the viewer. Plus, they can evoke strong feelings.
                Talking about the trust built by actual environments and real actors, or presenters, the huge advantages of live-action videos become
                more than clear.
              </p>
              <div className={'mt-20 block md:hidden'}>
                <ViewMore ln={40}>
                  An amazing short movie that helps viewers understand ideas in an easy way. Here is a live action explainer video! It smoothly mixes
                  real-world elements, interesting narration, and voiceovers to describe a product, service, or idea. What are the benefits of these
                  videos over animations? They add a human touch to the message speaking directly to the viewer. Plus, they can evoke strong feelings.
                  Talking about the trust built by actual environments and real actors, or presenters, the huge advantages of live-action videos
                  become more than clear.
                </ViewMore>
              </div>
            </div>
            <br className={'clear-both hidden'} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full md:w-75p font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Where To Use Live Action Explainer Videos?
            </h2>
            <p className={'mt-20'}>
              It's the right time to get closer to your audience and connect with them on a human level. Your best companion on that journey is a
              user-friendly live action explainer video. It will lead you to effective communication and real results. As the most widely produced
              video product globally, it serves various objectives across different industries.
            </p>

            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between items-start mt-0 md:mt-24">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/uzkLxMoRIcU?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Mi Amor | Jewelry Live Action Video</p>
              </div>

              <div className={'w-full md:w-half-auto mt-24 md:mt-0'}>
                <h3 className="text-purple font-bold text-24   leading-none">Marketing and Advertising</h3>
                <div className={'mt-16 hidden md:block'}>
                  Live action explainer videos have the highest ROI and are the most effective for lead generation. And when it comes to presenting a
                  physical product and services, nothing beats their realism. They are the heart of e-commerce and online services, offering a real
                  insight into the product and its benefits. An explainer video live-action is a potent tool for businesses aiming to engage the
                  audience and set themselves apart in the crowded market.
                </div>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Live action explainer videos have the highest ROI and are the most effective for lead generation. And when it comes to presenting
                    a physical product and services, nothing beats their realism. They are the heart of e-commerce and online services, offering a
                    real insight into the product and its benefits. An explainer video live-action is a potent tool for businesses aiming to engage
                    the audience and set themselves apart in the crowded market.
                  </ViewMore>
                </div>
              </div>
            </div>

            <div className="flex flex-wrap md:flex-nowrap justify-between mt-0 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <h3 className="text-purple font-bold text-24 leading-none">Education and Training</h3>
                <p className={'mt-16'}></p>

                <p className={'mt-16 hidden md:block'}>
                  Times change, technology evolves, but human nature remains the same. Even today, the best source of learning for people is other
                  people. And how to connect a person with another person regardless of time and space? A live action explainer video is the best
                  solution. It's a useful tool for creating high-quality training modules and online courses. By connecting with the viewer on a
                  personal level and boosting focus, it simplifies complex subjects, making them interesting and impressive.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={40}>
                    Times change, technology evolves, but human nature remains the same. Even today, the best source of learning for people is other
                    people. And how to connect a person with another person regardless of time and space? A live action explainer video is the best
                    solution. It's a useful tool for creating high-quality training modules and online courses. By connecting with the viewer on a
                    personal level and boosting focus, it simplifies complex subjects, making them interesting and impressive.
                  </ViewMore>
                </div>
              </div>
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/2QgHNcmwPaM?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Ti Amo | Jewelry Live Action Video</p>
              </div>
            </div>
            <div className="flex flex-wrap-reverse md:flex-nowrap justify-between mt-24 md:mt-48">
              <div className={'w-full md:w-half-auto mt-24 md:mt-0 '}>
                <LazyLoad height={315} offset={100}>
                  <iframe
                    width="560"
                    height="315"
                    className="w-full"
                    src="https://www.youtube.com/embed/kS7PbRZ_YpA?controls=0"
                    title="YouTube video player"
                    allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                    allowFullScreen
                  ></iframe>
                </LazyLoad>
                <p className={'font-medium text-14 leading-24 text-center mt-8 text-gray-dark'}>Beeline | Corporate Live Action Video</p>
              </div>

              <div className={'w-full md:w-half-auto '}>
                <h3 className="text-purple font-bold text-24 leading-none">Corporate Communication</h3>
                <p className={'mt-16 hidden md:block'}>
                  Create a deep connection and community sense around your company. Humanize your brand with live-action explainer video and talk to
                  your audience like a person to a person. It's the best way to engage, educate, and inform them. Depth, trust, and added value -
                  that's what live-action explainer video will bring to your corporate communication strategy.
                </p>
                <div className={'mt-16 block md:hidden'}>
                  <ViewMore ln={'40'}>
                    Create a deep connection and community sense around your company. Humanize your brand with live-action explainer video and talk to
                    your audience like a person to a person. It's the best way to engage, educate, and inform them. Depth, trust, and added value -
                    that's what live-action explainer video will bring to your corporate communication strategy.
                  </ViewMore>
                </div>
              </div>
            </div>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-gray-light py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              Benefits of Live Action Explainer Video
            </h2>
            <p className={'mt-20'}>
              A live action explainer video is ahead of its animated "friends" in terms of cost and length of production․ But does this overshadow its
              power? Our short answer is NO. It offers unique benefits that no animation can.
            </p>
            <Suspense fallback={`Loading...`}>
              <BenefitsLiveAction />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="text-purple text-24 md:text-36 text-left mb-23 font-black uppercase leading-none">
              Our Live Action Explainer Video Production Process
            </h2>
            <ProcessSliderLiveAction />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={0} once>
        <div className={'h-500 md:h-310 overflow-hidden relative ' + st['bg-contact']}>
          <div id="stars" />
          <div id="stars2" />
          <div id="stars3" />
          <div className="container flex flex-wrap md:flex-nowrap justify-between items-end md:items-center h-full ">
            <div className={'mt-24 md:mt-0 text-left md:text-center font-bold uppercase  text-white leading-28 md:leading-44   text-20 md:text-36'}>
              CALCULATE YOUR LIVE ACTION EXPLAINER VIDEO PRICE
              <br />
              <span className={'pt-20 font-normal normal-case text-18 md:text-24 leading-20 md:leading-29 '}>
                Answer five questions and get to know the price!
              </span>
              <div className={'flex justify-end md:justify-center mt-0 leading-0'}>
                <button
                  onClick={showPricingModal}
                  className="uppercase h-40 text-18 leading-24  hover:bg-green-hover md:flex justify-center items-center   w-auto mt-24 text-white bg-green rounded-5 px-23 py-0 md:py-5"
                >
                  Start Now
                </button>
              </div>
            </div>
            <img src="https://weprodigi.com/uploads/images/explainer-videos/Inga.webp" alt="eva" className={st['inga']} />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className={'bg-white py-24'}>
          <div className="container">
            <h2 className={'w-full font-bolder text-24 md:text-36 leading-28 md:leading-44 uppercase text-black'}>
              How Live Action Explainer Video Can Help Your Business?
            </h2>
            <p className={'mt-20'}>
              Live action explainer videos impress with their authenticity and tangibility. But this is only the external side of their power. They
              are also valuable business tools.
            </p>
            <Suspense fallback={`Loading...`}>
              <SolveProblemsLiveAction />
            </Suspense>
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-gray-light">
          <div className="container py-23">
            <h2 className="uppercase text-30 md:text-36 mb-23 font-black text-purple leading-none">
              Why Choose Us for Your Live Action Explainer Video Production?
            </h2>
            <Why
              content={[
                {
                  title: 'We ensure technical excellence.',
                  answer:
                    'Our experienced specialists work only with the best cameras, sound, and light devices to ensure the highest quality of your video.',
                },
                {
                  title: 'We develop compelling narratives.',
                  answer: 'Based on deep research, we define the best visual aesthetics and choose the appropriate style and tone for your message.',
                },
                {
                  title: 'We value your time.',
                  answer: 'Throughout the process of video production, we use proven methods to save you time.',
                },
                {
                  title: 'We don’t require prepayment.',
                  answer: 'We picked the milestone payment method, as we believe that it is the best option for both us and our clients.',
                },
              ]}
            />
          </div>
        </div>
      </LazyLoad>

      <LazyLoad height={200} once>
        <div className="bg-white">
          <div className="container py-23">
            <h2 className="uppercase text-24 md:text-36 mb-23 font-black text-purple leading-none">FAQ</h2>
            <div className="grid md:grid-cols-2 md:gap-30">
              <Faq
                content={[
                  {
                    title: 'How long should an explainer video last?',
                    answer:
                      'The ideal length of explainer videos depends on the topic, target audience, and platform. Yet, many experts recommend keeping them short and concise, between 60 and 90 seconds.',
                  },
                  {
                    title: 'How much does live action explainer video cost?',
                    answer: 'The average cost of a custom live action explainer video, running from 45 seconds to 1 minute, starts at $3500.',
                  },
                ]}
              />
              <Faq
                content={[
                  {
                    title: 'Which one is more effective: live action explainer video or 3D animated?',
                    answer:
                      'The decision between 3D animation and live-action depends on your goals, target audience, and the message you want to convey. Both styles have their unique strengths and can be used effectively across various platforms.',
                  },
                  {
                    title: 'Are live action explainer videos effective?',
                    answer:
                      'Live action explainer videos are highly effective. They resonate with the viewers on a more personal level, fostering a deep connection that goes beyond the product/service itself.',
                  },
                ]}
              />
            </div>
          </div>
        </div>
      </LazyLoad>

      <Pricing videoLength={videoLength} script={script} country={props.country} show={showPricingModalF} hide={hidePricingModal} step={1} />
    </>
  );
};

export default ExplainerVideosLiveAction;
